export default "__VITE_ASSET__33687dd5__"